export default __webpack_public_path__ + "static/media/property.01d3f33e.png";